export default "<main id=\"main\" aria-role=\"main\" class=\"dashboard-page\">\n  <es-pick-and-pack class=\"flex flex-col flex-1\"/>\n</main>\n"